import { toast } from "sonner";

// Messages des popups gardés pour être relus (Alex 2026-10-28 : « j'ai vu des popups mais trop rapide pour que je lise…
// ajoute les contenus des popups dans une page de log ») : chaque toast affiché est aussi noté ici, les 50 derniers, et
// la cloche les montre sous « Messages récents ».
// MÉMOIRE DE L'ONGLET SEULEMENT, jamais localStorage ni le serveur (Jimmy 2026-10-28) : un message d'erreur du serveur ou
// un avertissement d'import peut citer le script ; rien n'en est écrit sur le disque. Un rechargement vide la liste.
const MAX = 50;
let memory = [];
let installed = false;

const textOf = (m) => (typeof m === "string" ? m : typeof m === "number" ? String(m)
  : m && typeof m === "object" && typeof m.message === "string" ? m.message : "");

export function readToastLog() {
  return memory;
}

function write(list) {
  memory = list;
  try { window.dispatchEvent(new Event("toastlog")); } catch { /* hors navigateur */ }
}

// `kind` : success | error | info | warning | message ; un toast sans texte lisible (élément React) n'est pas noté,
// ni `toast()` nu, `toast.loading` ou les issues de `toast.promise` (créées en interne par sonner)
export function recordToast(kind, message, options) {
  const text = textOf(message);
  const description = textOf(options?.description);
  if (!text && !description) return;
  write([{ kind, text: description ? `${text} — ${description}` : text, at: new Date().toISOString() },
    ...memory].slice(0, MAX));
}

export function clearToastLog() {
  write([]);
}

// une fois, au démarrage de l'app : les méthodes de `toast` (le même objet partout) notent puis affichent
export function installToastLog() {
  if (installed) return;
  installed = true;
  // une version locale (jamais en prod) gardait la liste dans localStorage : effacée si un navigateur l'a encore
  try { localStorage.removeItem("mw_toast_log"); } catch { /* stockage indisponible */ }
  for (const kind of ["success", "error", "info", "warning", "message"]) {
    const original = toast[kind];
    if (typeof original !== "function") continue;
    toast[kind] = (message, options) => {
      try { recordToast(kind, message, options); } catch { /* la note ne bloque jamais l'affichage */ }
      return original(message, options);
    };
  }
}
